import { TEntryKind } from './campaign-team.interface';

export function idFor(kind: TEntryKind, id: string): string {
  return `${kind}:${id}`;
}

export function parseEntryId(entryId: string): { kind: TEntryKind; id: string } | null {
  const separatorIndex = entryId.indexOf(':');

  if (separatorIndex === -1) {
    return null;
  }

  const kind = entryId.slice(0, separatorIndex);
  const id = entryId.slice(separatorIndex + 1);

  return kind === 'user' || kind === 'team' ? { id, kind } : null;
}
